import React from "react";

export const PhoneFIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M11.9994 23.9529C18.5269 23.9529 23.9524 18.5274 23.9524 11.9999C23.9524 5.46088 18.5149 0.046875 11.9874 0.046875C5.44888 0.046875 0.046875 5.46088 0.046875 11.9999C0.046875 18.5274 5.46038 23.9529 11.9994 23.9529ZM8.94138 14.9179C6.03488 12.0229 4.18338 8.33187 6.37488 6.14038C6.50388 6.01137 6.64438 5.88288 6.77338 5.75388C7.44138 5.12088 8.08587 5.15638 8.65987 5.96488L10.1834 8.13288C10.6989 8.88288 10.5699 9.30437 10.0194 9.89038L9.53888 10.4179C9.36338 10.5819 9.43388 10.8044 9.51538 10.9454C9.73837 11.3669 10.3709 12.1169 11.0504 12.7969C11.7539 13.4999 12.4684 14.0974 12.9139 14.3434C13.0779 14.4374 13.3124 14.4609 13.4649 14.3204L13.9684 13.8399C14.5309 13.2889 14.9884 13.1484 15.7149 13.6639C16.4488 14.1858 17.1872 14.7015 17.9299 15.2109C18.6679 15.7499 18.8434 16.4179 18.0934 17.0974C17.9649 17.2264 17.8474 17.3674 17.7184 17.4959C15.5274 19.6759 11.8474 17.8239 8.94138 14.9179Z"
        fill="#333333"
      />
    </svg>
  );
};
